<template>
  <div v-if="state" class="mb-4 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
    <AlertTriangleIcon class="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600" />
    <span v-if="state.type === 'plain'" class="text-sm text-amber-700">{{ state.text }}</span>
    <span v-else class="text-sm text-amber-700">
      {{ t('eventNotification.templateVariableIssueDefaultPartBefore') }}
      <span class="mt-[2px]">{{
        t('eventNotification.templateVariableIssueDefaultPartHighlight')
      }}</span>{{ t('eventNotification.templateVariableIssueDefaultPartAfter') }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import { AlertTriangleIcon } from '@gohighlevel/ghl-icons/24/outline'
  import { type PropType } from 'vue'
  import { useI18n } from 'vue-i18n'
  import type { TemplateVariableValidationBannerState } from './templateVariableValidationBannerState'

  defineProps({
    state: {
      type: null as unknown as PropType<TemplateVariableValidationBannerState>,
      default: null,
    },
  })

  const { t } = useI18n()
</script>
